import React, { useState, useEffect } from "react";
import { useNavigate, Link, useLocation  } from 'react-router-dom';
import { useAdminAuth } from '../../../context/AdminAuthContext';
import '../../css/styles.css';

const Header = () => {
    const { isAdmin, logout } = useAdminAuth();
    const location = useLocation();
    const navigate = useNavigate();
    const [searchQuery, setSearchQuery] = useState('');
    const [searchResults, setSearchResults] = useState([]);

    const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    };

    const handleSearchSubmit = (event) => {
        event.preventDefault();
        const currentPage = location.pathname;
        if (searchQuery) {
            navigate(`${currentPage}?search=${searchQuery}`);
        }
    };
    
    const handleLogout = () => {
        alert("Has salido de la edición");
        logout();
    };

    useEffect(() => {
    if (searchQuery) {
        fetch(`https://grupo.us.es/ligaincom/api/search.php?search=${searchQuery}`)
            .then(response => response.json())
            .then(data => {
                setSearchResults(data); // Guardamos los resultados
            })
            .catch(error => console.error("Error en la búsqueda:", error));
    }
}, [searchQuery]);

    return (
        <header>
            <nav className="navbar navbar-expand-lg navbar-light">
                <Link className="navbar-brand" to={`/ligaincom`}>
                    <img src={`https://grupo.us.es/ligaincom/public/uploads/images/logo.png`} width="180px" height="auto" alt="Logo" />
                </Link>
                <button className="navbar-toggler toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                
                {/* Todo lo que debe colapsar debe ir dentro de este div */}
                <div className="collapse navbar-collapse collapsed" id="navbarNav">
                    <ul className="navbar-nav me-auto">
                        <li className="nav-item">
                            <Link className="nav-link" to="/ligaincom/cursos">Cursos</Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link ms-2" to="/ligaincom/divulgacion">Divulgación y Transferencia</Link>
                        </li>
                        <li className="nav-item dropdown">
                            <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown1" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                Investigación
                            </a>
                            <ul className="dropdown-menu dropdown" aria-labelledby="navbarDropdown1">
                                <li>
                                    <Link className="dropdown-item" to="/ligaincom/congresos_seminarios">Congresos y Seminarios</Link>
                                </li>
                                <li>
                                    <Link className="dropdown-item" to="/ligaincom/proyectos">Proyectos</Link>
                                </li>
                                <li>
                                    <Link className="dropdown-item" to="/ligaincom/publicaciones">Publicaciones</Link>
                                </li>
                            </ul>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link" to="/ligaincom/integrantes">Integrantes</Link>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="mailto:ligaincom@us.es">Contacta</a>
                        </li>
                    </ul>

                    <div className="d-flex ms-auto align-items-center">
                        {isAdmin && (
                            <button
                                className="btn logout-btn"
                                style={{
                                    backgroundColor: 'white',
                                    border: '5px solid #005EC4',
                                    borderRadius: '20px',
                                    color: '#005EC4',
                                    cursor: 'pointer',
                                    padding: '10px',
                                    textDecoration: 'none'
                                }}
                                onClick={handleLogout}
                            >
                                Logout
                            </button>
                        )}
                        {/*<form className="search">
                            <input className="form-control me-2" type="search" aria-label="Buscar" />
                            <button className="btn btn-outline-success searchbutton" type="submit">Buscar</button>
                        </form>*/}
                    </div>
                </div>
            </nav>
        </header>
    );
};

export default Header;
